




























































































































import { Component, Vue } from 'vue-property-decorator';
import { AxiosError } from 'axios';
import dayjs from 'dayjs';

import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import Loader from '@/components/Loader.vue';
import api from '@/libs/api';
// eslint-disable-next-line import/named
import { DetailVA } from '@/libs/api.interfaces';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import numberFormat from '@/libs/numberFormat';
import channels from '@/configs/paymentChannels';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    StatusIndicator,
    Loader,
  },
  methods: {
    numberFormat,
  },
})
export default class ReportDetail extends Vue {
  channels = channels;
  currentChannel = { title: '', code: '' };
  tb = '';

  loading = false;
  transactionDate = '';
  transactionExpired = '';
  merchantName = '';
  brandName = '';
  description = '';
  reason = '';

  transactionNo = '';
  currency = '';
  amount = '';
  flagStatus = '';
  transactionMessage = '';
  additionalData = '';

  customerName = '';
  customerEmail = '';

  customerNumber = '';
  customerAddress = '';

  paymentChannel = '';
  paymentDate = '';
  channelID = '';
  channelType = '';
  paymentMessage = '';

  virtualAccountNumber = '';
  reference = '';
  serviceCode = '';
  authCode = '';

  productName = '';
  quantity = '';

  transactionStatus = {
    '00': 'Success',
    '01': 'Failed',
  }

  numberFormat!: typeof numberFormat;

  beforeMount() {
    this.currentChannel = this.channels[this.$route.params.channel];
    this.tb = this.$route.params.tb;
  }

  mounted() {
    this.getDetail();
  }

  async getDetail() {
    const { id } = this.$route.params;

    try {
      this.loading = true;
      const { data } = await api.get<DetailVA>(`transaction/detail/${id}`, {
        params: {
          tb: this.tb,
        },
      });
      this.transactionDate = data.transactionDate;
      this.transactionExpired = data.transactionExpire;
      this.merchantName = data.merchantName;
      this.brandName = data.brandName;
      this.description = data.description;
      // const reason = data.flagReasonId !== '' || data.flagReasonEn !== ''
      //   ? `Ind : ${data.flagReasonId}, Eng : ${data.flagReasonId}` : '-';
      this.reason = data.flagReasonEn;

      this.transactionNo = data.transactionNo;
      this.currency = 'IDR';
      this.amount = data.amount;
      this.flagStatus = data.flagStatus;
      this.transactionMessage = '';
      this.additionalData = '';

      this.customerName = data.customerName;
      this.customerEmail = data.customerEmail;

      this.customerNumber = data.customerNumber || data.customerPhone;
      this.customerAddress = data.customerAddress;

      this.paymentChannel = this.currentChannel.title;
      this.paymentDate = data.paymentDate;
      this.channelID = data.channelId;
      this.channelType = data.serviceType;
      this.paymentMessage = '-';

      this.virtualAccountNumber = data.virtualAccountNumber;
      this.reference = data.reference;
      this.serviceCode = '';
      this.authCode = '';

      this.productName = '';
      this.quantity = '';

      this.loading = false;
    } catch (err) {
      console.error(err);
      showToast(
        ToastType.FAILED,
        `Error [${(err as AxiosError).response?.status}]`,
        'Failed to get transaction detail',
      );
    }
  }

  // eslint-disable-next-line class-methods-use-this
  dateFormat(time: string) {
    return dayjs(time).format('MMMM D, YYYY HH:mm:ss');
  }
}
